import React from "react"
import { Button, ControlLabel, FormControl, FormGroup } from "react-bootstrap"
import Option from "./Option"
import { ALL_OF_THE_ABOVE } from "./index"


export default function Question(props) {
  // PROPS
  const {
    index,
    question,
    removeQuestion,
    editQuestion,
    addOption,
    editOption,
    removeOption,
    formErrors
  } = props

  return (
    <tr className="question-row">
      <td style={{ width: "2%" }}>{ index + 1 }.</td>
      <td>
        <FormGroup validationState={
          formErrors[question.id] && formErrors[question.id]['name'] ? 'error' : null
        }>
          <FormControl
            componentClass="textarea"
            style={{ marginBottom: "5px", resize: "none" }}
            rows={ 5 }
            value={ question.name }
            onChange={ (e) => editQuestion(question.id, "name", e.target.value) }
          />
          <div className="add-option-button">
            <Button bsStyle="danger" onClick={() => removeQuestion(question.id)}>Remove Question</Button>
          </div>
          <div className="question-error-label">
            <FormGroup validationState={ formErrors[question.id] ? "error" : null }>
              <ControlLabel>{ formErrors[question.id] ? formErrors[question.id]['name'] : null }</ControlLabel>
            </FormGroup>
          </div>
        </FormGroup>
      </td>
      <td className="option-col">
        { question.options.map((option, index) => (
          <Option
            key={ index }
            option={ option }
            question={ question }
            editOption={ editOption }
            removeOption={ removeOption }
            showError={
              (formErrors[question.id] && formErrors[question.id]['options'])
              ||
              (formErrors[option.id] && formErrors[option.id]['name'])
            }
            formErrors={ formErrors }
          />
        ))}
        <div className="add-option-button">
          { question.type !== "Boolean" && <Button onClick={ () => addOption(question.id) }>Add Option</Button> }
          { question.type === "Radio" &&
            <Button
              className="add-all-of-the-above-option"
              onClick={ () => addOption(question.id, true) }
              disabled={ !!question.options.find(option => option.name === ALL_OF_THE_ABOVE) }
            >
              Add { ALL_OF_THE_ABOVE }
            </Button>
          }
        </div>
        <div className="question-error-label">
          <FormGroup validationState={ formErrors[question.id] ? "error" : null }>
            <ControlLabel>{ formErrors[question.id] ? formErrors[question.id]['options'] : null }</ControlLabel>
          </FormGroup>
        </div>
      </td>
    </tr>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/EditAssessmentModal/Question.js